<c-card class="mb-4">
  <c-card-header class="bg-primary text-white" ngPreserveWhitespaces>
    <strong>Captura de Incidencias por Lote</strong> <small>Incidencias</small>
  </c-card-header>

  <c-card-body>
    <form [formGroup]="guardarFG" cRow *ngIf="permisos.edicion">
      <c-col [xs]="4" class="mt-2">
        <label cLabel for="id">Planta</label>
        <select
          cSelect
          formControlName="idNumFacilityId"
          [disabled]="disableForm || isNuevoClicked"
        >
          <option
            *ngFor="let opcion of listaPlantas"
            [value]="opcion.facilityId"
            [hidden]="opcion.facilityId == 10"
          >
            {{ opcion.facilityDescription }}
          </option>
        </select>
      </c-col>
      <c-col [xs]="4" class="mt-2">
        <label cLabel for="id">Tipo</label>
        <select
          cSelect
          formControlName="idCmbTipo"
          [disabled]="disableForm || isNuevoClicked"
        >
          <option *ngFor="let opcion of listaTipo" [value]="opcion.id">
            {{ opcion.nombre }}
          </option>
        </select>
      </c-col>
      <c-col [xs]="4" class="mt-2">
        <label cLabel for="id">Semana</label>
        <input
          cFormControl
          id="idNumSemana"
          required
          type="number"
          min="0"
          formControlName="idNumSemana"
          (input)="validateWeekInput($event, 2)"
          maxlength="2"
          [disabled]="disableForm || isNuevoClicked"
        />
      </c-col>
      <c-col [xs]="4" class="mt-2">
        <label cLabel for="id">Concepto</label>
        <select
          cSelect
          formControlName="idCmbConceptoid"
          [disabled]="disableForm || isNuevoClicked"
        >
          <option *ngFor="let opcion of listaConceptos" [value]="opcion.id">
            {{ opcion.tipo.charAt(0) }}{{ opcion.clave }}
            {{ opcion.descripcion }}
          </option>
        </select>
      </c-col>

      <c-col [xs]="12" class="mt-2" *ngIf="listaPartner.length > 0">
        <div class="table-wrapper">
          <table cTable class="table">
            <thead class="table-primary">
              <tr>
                <th style="width: 10%" scope="col">Proveedor</th>
                <th style="width: 35%" scope="col">Importe</th>
                <th style="width: 55%" scope="col">Comentario</th>
              </tr>
            </thead>
            <tbody>
              <tr
                *ngFor="
                  let dato of datosTabla;
                  let i = index;
                  trackBy: trackByFn
                "
              >
                <td>
                  <select
                    cSelect
                    (change)="onBlurSocio($event.target.value, i)"
                    value=""
                    formControlName="socioSeleccionado"
                  >
                    <option></option>
                    <option
                      [value]="socios.partnerNumber"
                      *ngFor="let socios of listaPartner"
                    >
                      {{ socios.partnerNumber }}
                    </option>
                  </select>
                </td>
                <td
                  contenteditable="true"
                  class="importe-cell"
                  (keyup)="keyUpMeto($event, i)"
                  (blur)="onImporteChange($event, i)"
                  (keypress)="validateFormat($event)"
                >
                  {{ dato.importe }}
                </td>
                <td
                  contenteditable="true"
                  (blur)="onComentarioChange($event, i)"
                >
                  {{ dato.comentario }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        
        <c-button-group class="table" aria-label="Basic example" role="group">
          <button
            (click)="showGuardar()"
            cButton
            color="primary"
            type="submit"
            id="btnNew"
          >
            Guardar
          </button>
          <button
            (click)="showNuevo()"
            cButton
            color="primary"
            type="button"
            id="btn"
          >
            Nuevo
          </button>
        </c-button-group>
      </c-col>
<!-- 
      <c-col [xs]="4" class="mt-2">
      </c-col>

      <c-col [xs]="4" class="mt-2">
        <c-button-group class="table" aria-label="Basic example" role="group">
        </c-button-group>
      </c-col> -->
    </form>
    <div class="container-fluid py-5" *ngIf="!permisos.edicion">
      <h1 class="display-5 fw-bold">Sin permisos</h1>
      <p class="col-md-8 fs-4">
        No tiene permisos para realizar capturas por lotes.
      </p>
    </div>
  </c-card-body>
</c-card>
